
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiDelegatiConProprietaDialog extends Serenity.EntityDialog<UtentiDelegatiConProprietaRow, any> {
        protected getFormKey() { return UtentiDelegatiConProprietaForm.formKey; }
        protected getIdProperty() { return UtentiDelegatiConProprietaRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiDelegatiConProprietaRow.localTextPrefix; }
        protected getNameProperty() { return UtentiDelegatiConProprietaRow.nameProperty; }
        protected getService() { return UtentiDelegatiConProprietaService.baseUrl; }
        protected getDeletePermission() { return UtentiDelegatiConProprietaRow.deletePermission; }
        protected getInsertPermission() { return UtentiDelegatiConProprietaRow.insertPermission; }
        protected getUpdatePermission() { return UtentiDelegatiConProprietaRow.updatePermission; }

        protected form = new UtentiDelegatiConProprietaForm(this.idPrefix);

    }
}